import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { constants } from 'app/constants';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductGroupService {

  productGroupList: any;

  constructor(
    private http: HttpClient
  ) { }

  /**
   * Backend API to add the product group
   * @param productGroupForm : Filled Product Group form
   */
   getAllProductGroupApi() {
    return new Promise((resolve, reject) => {
      if (this.productGroupList) {
        resolve(this.productGroupList);
        return;
      }
      const endpointUrl = environment.host_api + 'product_group/';
      this.http.request('GET', endpointUrl, {})
      .subscribe(
        response => {
          if (response) {
            console.log('All Product Groups Received......');
            this.productGroupList = response;
            resolve(response);
          }
        },
        error => {
          console.log(error.error);
          reject(error.error);
        }
      );
    });
  }

  /**
   * Backend API to add the product group
   * @param productGroupForm : Filled Product Group form
   */
  addUpdateProductGroupApi(productGroupForm: UntypedFormGroup, requestMethod: string,  data: any = {}) {
    return new Promise((resolve, reject) => {
      const endpointUrl = environment.host_api + 'product_group/';
      
      if (requestMethod !== 'DELETE') {
        data = this.getDataFromForm(productGroupForm, data);
      }
      if (!data) {
        return reject();
      }

      this.http.request(requestMethod, endpointUrl, {body: data})
      .subscribe(
        response => {
          console.log('Product Group Addeddd......');
          resolve(response);
        },
        error => {
          console.log(error.error);
          reject(error.error);
        }
      );
    });
  }

  /**
   * Get the data from the form for backend API to add the product group
   * @param productGroupForm : Filled Product Group form
   */
  getDataFromForm(productGroupForm: UntypedFormGroup, data: any) {
    data['user_id'] = sessionStorage.getItem('user_id');
    data['product_grp_name'] = productGroupForm.get('productGroupName')?.value;
    data['column_factor_name'] = productGroupForm.get('productGroupColumnName')?.value;
    data['column_factor_values'] = this.getColumnFactorValuesInString(productGroupForm);
    data['metric_unit'] = productGroupForm.get('prodGroupUnitMeasure')?.value;
    return data;
  }

  /**
   * Get all the column values and convert it into string to save it in databse via backend api
   * @param productGroupForm : Filled Product Group form
   */
  getColumnFactorValuesInString(productGroupForm: UntypedFormGroup) {
    let factorValues : any = [];
    for (let i = 0; i < constants.FACTOR_VALUES_COUNT; i++) {
      const value = productGroupForm.get('productGroupColumnValue' + i)?.value;
      if (value == null || value == '' || value == undefined)
      {
        break;
      }
      factorValues.push(value);
    }
    return factorValues.join(',');
  }

  getSelectedProductInGrid(selectedRow: any, productGroupList: any) {
    for (let i = 0; i < productGroupList.length; i++) {
      if (selectedRow['product_grp_id'] === productGroupList[i]['id']) {
        return productGroupList[i];
      }
    }
    return null;
  }
  
}
